__turbopack_context__.v({
  "content": "Notification-module__Fy4epq__content",
  "dismiss": "Notification-module__Fy4epq__dismiss",
  "fullWidth": "Notification-module__Fy4epq__fullWidth",
  "icon": "Notification-module__Fy4epq__icon",
  "notification": "Notification-module__Fy4epq__notification",
  "text": "Notification-module__Fy4epq__text",
});
